import BaseResource from './BaseResource'

export default class Templates extends BaseResource {
  static endpoint = '/api/v1/templates' ///edge
}
